import { Component, Input, OnInit } from "@angular/core";
import { ProductDetailsUiStateService } from "../product-details-ui-state.service";
import { ActivatedRoute } from "@angular/router";
import { AbstractControl, FormArray, FormGroup } from "@angular/forms";
import {
  ClientTransactionForm,
  ClientTransactionViewForm,
} from "src/app/models/forms/transactions-form";

@Component({
  selector: "app-product-details-step1",
  templateUrl: "./product-details-step1.component.html",
  styleUrls: ["../online-product-details.component.scss"],
})
export class ProductDetailsStep1Component implements OnInit {
  @Input() clientTransactionViewForm: FormGroup<ClientTransactionViewForm>;

  get clientTransactionForm(): AbstractControl<ClientTransactionForm> {
    return this.pUiService.clientTransactionForm;
  }

  get apartmentSize(): AbstractControl<number> {
    return this.pUiService.apartmentSize;
  }

  get timeToGetProgramInDays(): AbstractControl<number> {
    return this.pUiService.timeToGetProgramInDays;
  }

  get existFileFormat(): AbstractControl<string> {
    return this.pUiService.existFileFormat;
  }

  get wantedFileFormat(): AbstractControl<string> {
    return this.pUiService.wantedFileFormat;
  }

  get fixesTimes(): AbstractControl<number> {
    return this.pUiService.fixesTimes;
  }

  get dynamicOptionResponses(): AbstractControl<
    FormArray
  > {
    return this.clientTransactionViewForm.get(["DynamicOptionResponses"]);
  }

  chosenOptionDoesNotExist: boolean = false;

  constructor(
    public pUiService: ProductDetailsUiStateService,
    private _route: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.apartmentSize.valueChanges.subscribe((val) => {
      this.changeApartmentOption(val);
    });
    this.timeToGetProgramInDays.valueChanges.subscribe(() => {
      this.changeSelectedDay();
    });
    this.existFileFormat.valueChanges.subscribe(() => {
      this.changeSelectedExistFileFormat();
    });

    this.wantedFileFormat.valueChanges.subscribe(() => {
      this.changeSelectedFinalFileFormat();
    });

    this.fixesTimes.valueChanges.subscribe(() => {
      this.changeNumberOfFIxes();
    });
    this.dynamicOptionResponses.valueChanges.subscribe(() => {
      this.pUiService.addToFinalPrice();
    });
    this.clientTransactionViewForm.valueChanges.subscribe((val) => {
      if(val.DynamicOptionResponses[1]?.DynamicOptionItemId ===5){
        console.log(val);
      }
      
    });
  }

  getSelectedDayPrice(): number {
    return this.pUiService.getSelectedDayPrice();
  }

  getSelectedExistFileFormatPrice(): number {
    return this.pUiService.getSelectedExistFileFormatPrice();
  }

  getSelectedWantedFileFormatPrice(): number {
    return this.pUiService.getSelectedWantedFileFormatPrice();
  }

  getSelectedFixTimePrice(): number {
    return this.pUiService.getSelectedFixTimePrice();
  }

  

  changeApartmentOption(apartmentSize: number): void {

    const nextOptionIndex = this.pUiService.productView.ProductOptionItems.findIndex(
      (x) => x.ProductOptionItem.ApartmentSize >= apartmentSize
    );
    if(nextOptionIndex!== this.pUiService.currentOptionIndex ){
      if (this.apartmentSize.dirty) {
        this._displayApartmentSizeChangeWarning();
      }
      this.pUiService.currentOptionIndex = nextOptionIndex;
      this.pUiService.chosenOption = this.pUiService.productView.ProductOptionItems[nextOptionIndex];
      
    };
    this.pUiService.updateFields();
  }

  changeSelectedDay(): void {
    this.pUiService.markedFields[0] = false;

    this.pUiService.addToFinalPrice();
  }

  changeSelectedExistFileFormat(): void {
    this.pUiService.markedFields[1] = false;
    this.pUiService.addToFinalPrice();
  }

  changeSelectedFinalFileFormat(): void {
    this.pUiService.markedFields[2] = false;
    this.pUiService.addToFinalPrice();
  }

  changeNumberOfFIxes(): void {
    this.pUiService.markedFields[3] = false;
    this.pUiService.addToFinalPrice();
  }

  continueOrder(step: number): void {
    this.pUiService.continueOrder(step, this._route.snapshot.params.i);
  }

  scrollToPriceList(): void {
    document
      .querySelector(".order-btn-row")
      .scrollIntoView({ behavior: "smooth" });
  }


  private _displayApartmentSizeChangeWarning(): void {
    this.pUiService.displayGeneralComment = true;
    window.setTimeout(() => {
      this.pUiService.displayGeneralComment = false;
    }, 10000);
    window.setTimeout(() => {
      for (let i = 0; i < this.pUiService.markedFields.length; i++) {
        this.pUiService.markedFields[i] = true;
      }
    });
  }
  
}
